var map = {
	"./bronze-running-man.svg": 77353,
	"./diamond-running-man.svg": 18205,
	"./gold-running-man.svg": 16895,
	"./platinum-running-man.svg": 87545,
	"./silver-running-man.svg": 99886
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88990;